import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../commons";

export interface IManageTeamCoachAddState {
  manageTeamCoachAddStatus: StatusEnum;
}

export interface IManageTeamCoachAddOption {
  teamId: number;
  userId: number;
}

const initialState: IManageTeamCoachAddState = {
  manageTeamCoachAddStatus: StatusEnum.Idle,
};

export const teamCoachAdd = createAsyncThunk(
  "manage/teamCoachAdd",
  async (options: IManageTeamCoachAddOption, thunkAPI) => {
    try {
      const manageTeamCoachAdd = await manageFootballTeamService.addTeamCoach(options.teamId, options.userId);
      return manageTeamCoachAdd;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageTeamCoachAddSlice = createSlice({
  name: "manageTeamCoachAddSlice",
  initialState: initialState,
  reducers: {
    cleanUpTeamCoachAdd(state) {
      state.manageTeamCoachAddStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(teamCoachAdd.pending, (state) => {
        state.manageTeamCoachAddStatus = StatusEnum.Loading;
      })
      .addCase(teamCoachAdd.fulfilled, (state) => {
        state.manageTeamCoachAddStatus = StatusEnum.Succeeded;
      })
      .addCase(teamCoachAdd.rejected, (state) => {
        state.manageTeamCoachAddStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpTeamCoachAdd } = manageTeamCoachAddSlice.actions;
export default manageTeamCoachAddSlice.reducer;
